/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

// HTF-1482: written in the generated style until the identity client is regenerated with
// DisplayConfigurationSharedAppService. The URL must equal DISPLAY_CONFIGURATION_CURRENT_URL in
// @packages/display-policy (pinned by src/hooks/get/__tests__/useGetDisplaySettings.test.ts).
export class DisplayConfigurationSharedService {

    /**
     * Current company's display configuration; readable by any authenticated user.
     * @returns { decimalPrecision?: number | null } OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppDisplayConfigurationSharedCurrent(): CancelablePromise<{ decimalPrecision?: number | null }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/display-configuration-shared/current',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
